import * as e from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/UserCheck.es.js";
const o = e.forwardRef((r, c) => /* @__PURE__ */ e.createElement(s, { ref: c, ...r, weights: t }));
o.displayName = "UserCheckIcon";
const n = o;
export {
  n as UserCheck,
  o as UserCheckIcon
};
